<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
      <div class="mb3 text-left">
         <span class="no_permohonan">{{data.no_permohonan}}</span> | <w-tag class="mr4" bg-color="primary" round> {{data.status_keterangan}} </w-tag>
      </div>
    <z-page title="Maklumat Permohonan" >
      <div class="table_scrol">
        <table class="w-table" color="light" style="width: 100%; margin: 0;">
          <tbody><tr><td>
           <w-card bg-color="" class="">
             <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
               <div class="w-flex wrap smd-column">
                 <div class="grow xs12" style="line-height: 15px">
                   <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                     <tr class="row_data">
                       <td style="text-align: left; width: 28%; white-space: nowrap;">
                         <b>ID Premis</b>&nbsp;: {{data.no_nama_premis}}
                       </td>
                       <td style="text-align: left; width: 28%; white-space: nowrap;">
                         <b>Jenis Ternakan</b>&nbsp;: {{data.lkp_ternakan}}
                       </td>
                       <td style="text-align: left; width: 28%; white-space: nowrap;">
                         <b>Jenis Pengurusan</b>&nbsp;: {{data.lkp_status_perubahan}}
                       </td>
                       <template v-if="data.lkp_status_perubahan_id == 7">
                       <td style="text-align: left; width: 28%; white-space: nowrap;">
                         <b>Kategori</b>&nbsp;: {{ data.kategori_pwl == 1 ? 'PWL' : 'Bukan PWL' }}
                       </td>
                     </template>
                     <template v-if="data.lkp_status_perubahan_id == 46">
                       <td style="text-align: left; width: 28%; white-space: nowrap;">
                        <b>Kategori</b>&nbsp;: {{
                          data.kategori_lupus == 1
                            ? 'Sembelih'
                            : data.kategori_lupus == 2
                              ? 'Hilang'
                              : 'Singkir PWL'
                        }}
                    </td>
                     </template>
                     </tr>
                    </tbody>
                   </table>
                 </div>
               </div>
             </w-form>
           </w-card>
           </td></tr></tbody>
         </table>
        <br>
        <template v-if="data.lkp_status_perubahan_id == 42">
      <w-card 
         title-class="blue-dark4--bg white" 
         style="font-size: 13px;" 
         :title="'Butiran pemilik Asal'"
       >
         <div class="w-flex wrap smd-column">
                 <div class="grow xs12" style="line-height: 15px">
                   <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                     <tr class="row_data">
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>Nama</b>&nbsp;: {{data.user_nama}}
                       </td>
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>Alamat</b>&nbsp;: {{data.user_alamat}}
                       </td>
                     </tr>
                     <tr class="row_data">
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>No Tel</b>&nbsp;: {{data.user_no_tel}}
                       </td>
                     </tr>
                     </tbody>
                   </table>
                 </div>
               </div>
       </w-card>
       <br>
       <w-card 
         title-class="blue-dark4--bg white" 
         style="font-size: 13px;" 
         :title="'Butiran pemilik Baru'"
       >
         <div class="w-flex wrap smd-column">
                 <div class="grow xs12" style="line-height: 15px">
                   <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                     <tr class="row_data">
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>Nama</b>&nbsp;: {{data.nama}}
                       </td>
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>Alamat</b>&nbsp;: {{data.alamat}}
                       </td>
                     </tr>
                     <tr class="row_data">
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>No Tel</b>&nbsp;: {{data.no_tel}}
                       </td>
                     </tr>
                     </tbody>
                   </table>
                 </div>
               </div>
       </w-card>
    </template>
       <br>
        <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI TERNAKAN'">
  <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
    <template #title>
      SENARAI TERNAKAN
    </template>
    <div class="w-table-wrap" style="max-height: 400px;">
      <div class="table-profil-scrol">
        <table class="w-table" color="light">
          <thead>
            <tr>
              <th class="w-table__header text-center" width="1%">BIL</th>
              <th class="w-table__header text-center">NO PENDAFTARAN</th>
              <th class="w-table__header text-center">ID | NAMA TERNAKAN</th>
              <th class="w-table__header text-center">ID INDUK</th>
              <th class="w-table__header text-center">BAKA</th>
              <th class="w-table__header text-center">JANTINA</th>
              <th class="w-table__header text-center">TARIKH LAHIR</th>
              <th class="w-table__header text-center">UMUR (BULAN)</th>
              <template v-if="data.lkp_status_perubahan_id == 41">
                <th class="w-table__header text-center">TARIKH SINGKIR</th>
                <th class="w-table__header text-center">SEBAB SINGKIR</th>
              </template>
              <template v-if="data.lkp_status_perubahan_id == 7">
                <th class="w-table__header text-center">TARIKH KEMATIAN</th>
                <th class="w-table__header text-center">SEBAB KEMATIAN</th>
              </template>
              <th class="w-table__header text-center" width="10%">TINDAKAN</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(dt, ind) in data.ternakan_list" :key="dt.id">
              <tr class="w-table__row">
                <td class="w-table__cell text-center">{{ind+1}}</td>
                <td class="w-table__cell text-center">{{dt.no_pendaftaran}}</td>
                <td class="w-table__cell text-center">{{dt.ternakan_nama}}</td>
                <td class="w-table__cell text-center">{{dt.id_ibu}}</td>
                <td class="w-table__cell text-center">{{dt.lkp_baka}}</td>
                <td class="w-table__cell text-center">{{dt.jantina}}</td>
                <td class="w-table__cell text-center">{{$zutil.dateformat(dt.tarikh_lahir)}}</td>
                <td class="w-table__cell text-center">{{$zutil.umurbulan(dt.tarikh_lahir)}}</td>
                
                <template v-if="data.lkp_status_perubahan_id == 41">
                  <td class="w-table__cell text-center">{{$zutil.dateformat(dt.tarikh_singkir)}}</td>
                  <td class="w-table__cell text-center">{{dt.sebab_singkir}}</td>
                </template>
                
                <template v-if="data.lkp_status_perubahan_id == 7">
                  <td class="w-table__cell text-center">{{$zutil.dateformat(dt.tarikh_kematian)}}</td>
                  <td class="w-table__cell text-center">{{dt.sebab_kematian}}</td>
                </template>
                 
                <td class="w-table__cell text-center tindakan-cell">
                  <div class="button-group">
                    <w-button 
                      v-if="data.lkp_status_perubahan_id == 7 && data.kategori_pwl == 1"
                      class="be fs-2 action-button" 
                      bg-color="primary" 
                      dark 
                      tile 
                      @click="Milik(dt)"
                    ><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-eye</w-icon> 
                    </w-button>

                    <w-button 
                      v-else-if="data.lkp_status_perubahan_id == 42 || data.lkp_status_perubahan_id == 7 || data.lkp_status_perubahan_id == 46"
                      class="be fs-2 action-button" 
                      bg-color="primary" 
                      dark 
                      tile 
                      @click="Ternakan(dt)"
                    ><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-eye</w-icon> 
                    </w-button>

                    <w-button 
                      v-if="data.lkp_status_id == 18"
                      class="be fs-2 action-button"
                      bg-color="success"  
                      @click="cetak(dt.id)"
                    ><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-print</w-icon>
                    </w-button>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </w-form>
</w-card>
      <br>
      <template  v-if="$zutil.anyRole(['4'])" >
      <w-card 
         title-class="blue-dark4--bg white" 
         style="font-size: 13px;" 
         :title="'SAHKAN PERMOHONAN ?'"
       >
         <w-form 
           ref="zform" 
           v-model="valid" 
           v-model:errors-count="errorsCount" 
           @submit.prevent="validateForm" 
           @success="success"
         >
           <template #title>
             STATUS
           </template>

           <div class="w-table-wrap" style="max-height: 400px; padding: 1rem;">
             <w-radios
                v-model="form.lkp_status_id"
                :items="status_mohon"
                inline
                :validators="[validators.required]"
                color="blue-dark3"
                :disabled="data.lkp_status_id == 30 || data.lkp_status_id == 18"
              />
           </div>
         </w-form>
       </w-card>
     </template>
      
      <template  v-if="$zutil.anyRole(['1','6'])" >
        <w-card 
           title-class="blue-dark4--bg white" 
           style="font-size: 13px;" 
           :title="'Catatan Penyemak'"
         >
           <w-form 
             ref="zform" 
             v-model="valid" 
             v-model:errors-count="errorsCount" 
             @submit.prevent="validateForm" 
             @success="success"
           >
             <div class="w-table-wrap" style="max-height: 400px; padding: 1rem;">
               <span>{{data.catatan_pengurus}}</span>
             </div>
           </w-form>
         </w-card>
         <br>
       <template v-if="data.lkp_status_id != 18"> 
      <w-card 
         title-class="blue-dark4--bg white" 
         style="font-size: 13px;" 
         :title="'SAHKAN PERMOHONAN ?'"

       >
         <w-form 
           ref="zform" 
           v-model="valid" 
           v-model:errors-count="errorsCount" 
           @submit.prevent="validateForm" 
           @success="success"
         >
           <template #title>
             STATUS
           </template>

           <div class="w-table-wrap" style="max-height: 400px; padding: 1rem;">
             <w-radios
                 v-model="form.status_mohon"
                 :items="status_mohon"
                 inline
                 :validators="[validators.required]"
                 color="blue-dark3"
               />

           </div>
         </w-form>
       </w-card>
     </template>
      </template>
      <br>
               <w-card 
              title-class="blue-dark4--bg white" 
              style="font-size: 13px;" 
              :title="'CATATAN'"
            >
              <w-form 
                ref="zformPengurus" 
                v-model="valid" 
                v-model:errors-count="errorsCount" 
                @submit.prevent="validateFormPengurus" 
                @success="success"
              >
                <template #title>
                  CATATAN
                </template>

                <div class="w-table-wrap" style="max-height: 400px; padding: 1rem;">
                  <w-input 
                    v-if="(data.lkp_status_id == 31 || data.lkp_status_id == 30) && $zutil.anyRole(['4'])"
                    label="Catatan"
                    type="textarea"
                    v-model="form.catatan_pengurus"
                    :validators="[data.lkp_status_id == 21 ? validators.required : null]"
                    :disabled="data.lkp_status_id == 30 || data.lkp_status_id == 18"
                    outlined
                    rows="4"
                  />
                  <w-input 
                    v-else
                    label="Catatan"
                    type="textarea"
                    v-model="form.catatan_semakan_pengurus"
                    :validators="[data.lkp_status_id == 21 ? validators.required : null]"
                    :disabled="data.lkp_status_id == 21 || data.lkp_status_id == 18"
                    outlined
                    rows="4"
                  />
                </div>
              </w-form>
            </w-card>
               <w-flex class="mt3" wrap align-center justify-end v-if="data.lkp_status_id == 31 && $zutil.anyRole(['4'])">
                    <w-button class="my1" :loading="form.submitted && !form.sent" @click="sendPengurus(2)">
                         <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
                    </w-button>
                    &nbsp;
                    <w-button class="my1" bg-color="success" type="submit" :loading="form.submitted && !form.sent" @click="sendPengurus(1)">
                       <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
                    </w-button>
                  </w-flex>
               <w-flex class="mt3" wrap align-center justify-end  v-if="$zutil.anyRole(['1','6']) && data.lkp_status_id == 30">
                  <w-button class="my1" bg-color="success" type="submit" :loading="form.submitted && !form.sent" @click="sendPengurusByStatus()"> <!-- 3 hantar semakan -->
                     <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
                  </w-button>
               </w-flex>
             <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </div>
    </z-page>
    <w-dialog
      v-model="dialogMilik.show"
      :fullscreen="dialogMilik.fullscreen"
      width="700"
      :persistent="dialogMilik.persistent"
      :persistent-no-animation="dialogMilik.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
        Dokumen
      </template>

      <w-form
        ref="form_milik"
        v-model="dialogMilik.valid"
        @validate="validateFormMilik"
        @success="success">
        <div class="w-flex wrap smd-column">
          <div class="grow">
            <!-- <div
              v-for="(dt, ind) in form.ternakan_list"
              :key="dt.id"
              class="pa3 mb3 rounded-lg border border-grey-light5">
               -->
              <div class="w-flex smd-column">
                
                <div class="grow pr4">
                  <span class="mt4 block"><b>Muat Naik Salinan Dokumen</b></span>
                  <div class="mb2">Laporan Postmortem dari (PVD Daerah/ DVS Negeri/ Makmal Kesihatan Veterinar):
                     <template v-for="dt, ind  in attahecmentPostmertem">
                        <div class="fw-normal my1 fs-1">  
                           <a :href="dt.url">{{ dt.name }}</a>
                        </div>
                     </template>
                  </div>
                  <br>
                  <div class="mb2">Surat Perakuan Pampasan: 
                  <template v-for="dt, ind  in attahecmentPampasan">
                        <div class="fw-normal my1 fs-1">  
                           <a :href="dt.url">{{ dt.name }}</a>
                            <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                        </div>
                     </template>
                  </div>
                  <div class="mb2">Permit Sembelih: 
                  <template v-for="dt, ind  in attahecmentPermit">
                     <div class="fw-normal my1 fs-1">  
                        <a :href="dt.url">{{ dt.name }}</a>
                         <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                     </div>
                  </template>
                  </div>
                  <br>
                  <span class="mt4 block"><b>Muat Naik Gambar Terkini</b></span>
                  <br>
                  <div class="mb2">Gambar Sebelum: 
                  <template v-for="dt, ind  in attahecmentImgSebelum">
                     <div class="fw-normal my1 fs-1">  
                        <a :href="dt.url">{{ dt.name }}</a>
                         <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                     </div>
                  </template>
                  </div>
                  <div class="mb2">Gambar Semasa:
                  <template v-for="dt, ind  in attahecmentImgSemasa">
                     <div class="fw-normal my1 fs-1">  
                        <a :href="dt.url">{{ dt.name }}</a>
                         <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                     </div>
                  </template>
                  </div>
                  <br>
                  <span class="mt4 block"><b>Muat Naik Gambar Terkini</b></span>
                  <br>
                  <div class="mb2">Keputusan Darah:
                  <template v-for="dt, ind  in attahecmentDarah">
                     <div class="fw-normal my1 fs-1">  
                        <a :href="dt.url">{{ dt.name }}</a>
                         <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                     </div>
                  </template>
                  </div>
                  <br>
                </div>
              </div>
            </div>
          <!-- </div> -->
        </div>
      </w-form>

      <template #actions>
        <div class="spacer" />
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogMilik.show = false">
          TUTUP
        </w-button>

       <!--  <w-button
          class="ml1"
          :loading="dialogMilik.loading"
          @click="$refs.form_sijil.validate()">
          SIMPAN
        </w-button> -->
      </template>
    </w-dialog>

    <w-dialog
      v-model="dialogTernakan.show"
      :fullscreen="dialogTernakan.fullscreen"
      width="700"
      :persistent="dialogTernakan.persistent"
      :persistent-no-animation="dialogTernakan.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
        Maklumat Ternakan
      </template>

      <w-form
        ref="form_milik"
        v-model="dialogTernakan.valid"
        @validate="validateFormMilik"
        @success="success">
        <div class="w-flex wrap smd-column">
          <div class="grow">
            <div
              v-for="(dt, ind) in data.ternakan_list"
              :key="dt.id"
              class="pa3 mb3 rounded-lg border border-grey-light5">
              
              <div class="w-flex smd-column">
                
                <div class="grow pr4">
                  <div class="mb2"><b>No. Pendaftaran:</b> {{ dt.no_pendaftaran }}</div>
                  <div class="mb2"><b>ID/Nama Ternakan:</b> {{ dt.ternakan_nama }}</div>
                  <div class="mb2"><b>Jenis Ternakan:</b> {{ dt.lkp_ternakan }}</div>
                  <div class="mb2"><b>Baka:</b> {{ dt.lkp_baka }}</div>
                  <div class="mb2"><b>Jantina:</b> {{ dt.jantina }}</div>
                  <div class="mb2"><b>Tarikh lahir:</b> {{ dt.tarikh_lahir }}</div>
                </div>

                
                <div class="grow pl4 border-l border-grey-light5">
                  <div class="mb2"><b>ID Pejantan:</b> {{ dt.id_bapa }}</div>
                  <div class="mb2"><b>Baka Pejantan:</b> {{ dt.nama_bapa }}</div>
                  <div class="mb2"><b>ID Induk:</b> {{ dt.id_ibu }}</div>
                  <div class="mb2"><b>Baka Induk:</b> {{ dt.nama_ibu }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </w-form>

      <template #actions>
        <div class="spacer" />
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogTernakan.show = false">
          TUTUP
        </w-button>

       <!--  <w-button
          class="ml1"
          :loading="dialogMilik.loading"
          @click="$refs.form_sijil.validate()">
          SIMPAN
        </w-button> -->
      </template>
    </w-dialog>


  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource';
import VueQrcode from 'vue-qrcode'

export default {
  extends: ZResource,
  components: {
    VueQrcode,
  },
  props: {
    id: [Array, Object, String],

  },
  data() {
    return {
      // resourceurl: 'baka.permohonan',
      resourceurl: this.api_service + "baka",
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Baka Permohonan', route: '/baka/perubahan' },
        { label: 'Permohonan', route: '/baka/perubahan/permohonan' },
        { label: 'Papar', route: '/baka/perubahan/permohonan/'+this.id },
      ],

      title : '',
      form : {
        id : 0,
        catatan :'',
        lkp_baka_saranan_id : '',
        catatan_semakan: '',
        catatan_pengurus :'',
        catatan_semakan_pengurus :'',
        status_mohon :'',
        hantar : 0,
        submitted: false,
      sent: false,
      valid: false
        
      },
      activeTab : 0,
      ternakan_list:[],
      lkp_status : [],
      baka_dokumen_list:[],
      baka_saranan_list:[],
      status_mohon:[
        {value: 1, label: "Ya"},
      ],
      dialogMilik: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialogTernakan: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      penyakit_list:[
        {value: 1, label: "Positif"},
        {value: 2, label: "Negatif"},
        {value: 3, label: "Tiada Tanda Klinikal"},
      ],

      attahecmentImgSemasa:[],
      attahecmentImgSebelum:[],
      attahecmentDarah:[],
      attahecmentPostmertem:[],
      attahecmentPampasan:[],
      attahecmentPermit:[],
    }
  },
  validators: {
  
  validatePenyakitList: (value, context) => {
    
    if (context.form.hantar !== 1 && context.form.hantar !== 3) {
      return true; 
    }
    
    
    const penyakitList = context.data.baka_penyakit_list || [];
    const hasUnselected = penyakitList.some(item => !item.status);
    
    if (hasUnselected) {
      return "Sila pilih status untuk semua penyakit";
    }
    
    return true;
  }
},
  methods: {

    tutup(){
         this.$inertia.visit(window.route('baka.perubahan.index'));
       },

     nl2br(text) {
       if (!text) return '';
       return text.replace(/\\n/g, '<br>');
     },


        send(hantar) {
      this.form.hantar = hantar;

      if (hantar === 2) {
        this.onSuccessSimpan();
      } else {
        this.validateFormData();
      }
    },

    sendPengurusByStatus() {
    let hantar = 1; 
    this.sendPengurus(hantar); 
},
   
   Milik(dt){
       this.getAttahecmentImgSemasa(dt.id)
      this.getAttahecmentImgSebelum(dt.id)
      this.getAttahecmentDarah(dt.id)
      this.getAttahecmentPostmertem(dt.id)
      this.getAttahecmentPampasan(dt.id)
      this.getAttahecmentPermit(dt.id)
         
        this.dialogMilik.show = true;
        this.form.saveButton = "Simpan"
    },

    Ternakan(dt){
       
         
        this.dialogTernakan.show = true;
        this.form.saveButton = "Simpan"
    },

    validateFormData() {
        this.loading = true
        let isValid = true

        
        // if (!this.form.baka_id) {
        //   this.$zutil.notify("Rekod Baka tidak dijumpai", false)
        //   this.loading = false
        //   return false
        // }

        
        // if (this.form.lkp_status_id === 21 && !this.form.catatan_semakan) {
        //   this.$zutil.notify("Catatan wajib diisi", false)
        //   this.loading = false
        //   return false
        // }

        
        if (!this.form.hantar) {
          this.$zutil.notify("Pastikan Status Permohonan sudah terisi", false)
          this.loading = false
          return false
        }

        
        if (!isValid) {
          this.loading = false
          return false
        }

        
        this.onSuccess()
      },


     // onSuccessSimpan() {
     //            // alert(this.form.hantar);
     //             this.form.baka_id = this.data.id;
     //             // this.form.baka_penyakit_list = this.data.baka_penyakit_list;
     //             // this.form.baka_dokumen_list = this.data.baka_dokumen_list;

     //             this.$zcomm.post(this.resourceurl + '/simpan_baka', this.form)
     //             .then(res => {
     //                this.$zutil.notify("Baka berjaya Disimpan", true);
     //                this.$inertia.visit(this.$page.url)
     //              })
     //             .catch(error => {
     //                this.$zutil.notify("Ralat ketika menghantar Baka", false);
     //                console.error(error);
     //              })
     //             .finally(() => {
     //                this.loading = false;
     //              });
     //     },

      // onSuccess() {
      //      // if (this.form.hantar != 2) {
      //        // const hasUnselected = this.data.baka_penyakit_list.some(item => !item.status);
      //        // if (hasUnselected) {
      //        //   this.$zutil.notify("Sila pilih status untuk semua penyakit", false);
      //        //   return;
      //        // }
      //        this.$swal({
      //           title: 'Anda Pasti?',
      //       // text: "Are you sure want to delete this item!",
      //          type: 'warning',
      //          showCancelButton: true,
      //          confirmButtonColor: '#3085d6',
      //          cancelButtonColor: '#d33',
      //          confirmButtonText: 'Ya',
      //          cancelButtonText: 'Tidak'
      //        }).then((result) => {
      //          if (result.value) {

      //            // this.form.baka_id = this.data.id;

      //            this.$zcomm.post(this.resourceurl + '/simpan_baka', this.form)
      //            .then(res => {
      //               this.$zutil.notify("Baka berjaya dihantar", true);
      //               this.$inertia.visit(this.$route('perubahan.index', res.id));
      //             })
      //            .catch(error => {
      //               this.$zutil.notify("Ralat ketika menghantar Baka", false);
      //               console.error(error);
      //             })
      //            .finally(() => {
      //               this.loading = false;
      //             });
      //          }else{ }
      //        })
      //      // }

           
      //    },

         sendPengurus(hantar) {
            this.form.hantar = hantar;

            this.form.baka_id = this.data?.id;
            if (!this.form.baka_id) {
              this.$zutil.notify("Rekod Baka tidak dijumpai", false);
              return;
            }

            this.form.kategori_pwl = this.data?.kategori_pwl; 

            this.$zcomm.post(this.resourceurl + '/simpan_pengurus', this.form)
              .then(res => {
                this.$zutil.notify(hantar === 2 ? "Baka berjaya disimpan" : "Baka berjaya dihantar", true);
                if (hantar !== 2) {
                  this.$inertia.visit(this.$route('baka.perubahan.index', res.data.id));
                }
              })
              .catch(err => {
                console.error(err);
                this.$zutil.notify("Ralat ketika menghantar Baka", false);
              });
          },

         getStatus(){
         this.$zcomm.get(this.api_service + 'lookup/status_mohon', {}).then(res => {
           this.lkp_status = res
         })
       },


      getData() {
      this.$zcomm.get(this.api_service + 'baka/show/' + this.id, {})
        .then(res => {
          this.data = res ?? {}

          // Isi form dari data
          this.form.catatan = this.data.catatan ?? null
          this.form.catatan_semakan = this.data.catatan_semakan ?? null
          this.form.catatan_pengurus = this.data.catatan_pengurus ?? null
          this.form.catatan_semakan_pengurus = this.data.catatan_semakan_pengurus ?? null

          if (this.data.lkp_status_id == 18 || this.data.lkp_status_id == 21) {
            this.form.lkp_status_id = this.data.lkp_status_id ?? null
          }

          // Ternakan list
          if (Array.isArray(this.data.ternakan_list)) {
            this.data.ternakan_list.forEach(item => {
              if (item.pilih === undefined) {
                this.$set(item, 'pilih', false)
              }
            })

            // Baka saranan
            if (Array.isArray(this.data.baka_saranan_list) && this.data.lkp_baka_saranan_id) {
              this.data.baka_saranan_list.forEach(item => {
                if (item.lkp_baka_saranan_id == item.id) {
                  this.klickPi(item, item.lkp_baka_saranan_id)
                  return
                }
              })
            }
          }
        })
        .catch(error => {
          console.error("Error fetch data baka/show:", error)
          this.data = {} // fallback biar tetap object
        })
    },

    
  //   klickPi(item) {
  //   this.data.baka_saranan_list.forEach(dt => {
  //     if (dt.id !== item.id) {
  //       dt.pilih = false;
  //     }
  //   });
  // },
    klickPi(item, isChecked) {
    if (isChecked) {
      // Tandai hanya yang dipilih
      this.data.baka_saranan_list.forEach(dt => {
        dt.pilih = dt.id === item.id;
      });
      // Simpan id yang dipilih
      this.form.lkp_baka_saranan_id = item.id;
    } else {
      // Kalau tidak dicentang, hapus pilihan
      item.pilih = false;
      this.form.lkp_baka_saranan_id = null;
    }
  },
  cetak(id)
  {
      window.open('/baka/cetak/' + id, '_blank');
  },


  validateForm() {
    return this.$refs.zform.validate();
  },


       getAttahecmentImgSemasa(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranSemasa'}).then(res => {
           this.attahecmentImgSemasa = res
         })
       },

       getAttahecmentImgSebelum(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranSebelum'}).then(res => {
           this.attahecmentImgSebelum = res
         })
       },


       getAttahecmentDarah(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranDarah'}).then(res => {
           this.attahecmentDarah = res
         })
       },

       getAttahecmentPostmertem(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranPostmertem'}).then(res => {
           this.attahecmentPostmertem = res
         })
       },

       getAttahecmentPampasan(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranPampasan'}).then(res => {
           this.attahecmentPampasan = res
         })
       },

       getAttahecmentPermit(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranPermit'}).then(res => {
           this.attahecmentPermit = res
         })
       },

  },
  watch: {

  },
  mounted() {
    this.getData();
    this.getStatus();


  },
}
</script>

<style>
.tindakan-cell {
  min-width: 120px; 
}

.button-group {
  display: flex;
  gap: 4px; 
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap; 
}

.action-button {
  padding: 4px 8px !important; 
  margin: 0 !important; 
  min-width: 32px;
}

@media screen and (max-width: 1366px) {
  .action-button .w-icon {
    font-size: 14px !important;
  }
  
  .action-button {
    padding: 2px 6px !important;
  }
}

.abnormal-input {
  margin-top: 1rem;
}


.input-hint {
  color: black;
  font-size: 1.1em;
  display: block;
  margin-top: 8px;
  margin-bottom: 8px;
}

.no_permohonan {
    font-weight: bold;
    font-size: 16px;
    line-height: 30px;
}
table{
  width: 100%;
}
</style>
